import React from 'react';
import { AlertTriangle, CheckCircle, Clock } from 'lucide-react';

const MaintenanceCard = ({ type, lastIntervention, onAddIntervention }) => {
  const now = new Date();
  const isOverdue = lastIntervention?.nextDueDate && new Date(lastIntervention.nextDueDate) < now;
  const isDueSoon = lastIntervention?.nextDueDate && !isOverdue &&
    new Date(lastIntervention.nextDueDate) < new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);

  return (
    <div className={`bg-white rounded-lg shadow-sm border-l-4 p-4 ${
      isOverdue ? 'border-red-500' : isDueSoon ? 'border-orange-400' : 'border-primary'
    }`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className="font-semibold text-gray-800 flex items-center gap-2">
            {type.icon && <span>{type.icon}</span>}
            {type.name}
          </h3>
          {type.frequency && (
            <p className="text-xs text-gray-400 mt-0.5">
              Fréquence : tous les {type.frequency} mois
            </p>
          )}
        </div>
        {isOverdue && (
          <span className="flex items-center gap-1 text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded-full">
            <AlertTriangle size={12} />
            En retard
          </span>
        )}
        {isDueSoon && !isOverdue && (
          <span className="flex items-center gap-1 text-xs font-semibold text-orange-600 bg-orange-50 px-2 py-1 rounded-full">
            <Clock size={12} />
            Bientôt
          </span>
        )}
        {!isOverdue && !isDueSoon && lastIntervention && (
          <span className="flex items-center gap-1 text-xs font-semibold text-green-600 bg-green-50 px-2 py-1 rounded-full">
            <CheckCircle size={12} />
            À jour
          </span>
        )}
      </div>

      <div className="mt-3 space-y-1 text-sm">
        {lastIntervention ? (
          <>
            <p className="text-gray-600">
              Dernier passage : <span className="font-medium">{new Date(lastIntervention.date).toLocaleDateString('fr-FR')}</span>
              {lastIntervention.company && ` — ${lastIntervention.company}`}
            </p>
            {lastIntervention.nextDueDate && (
              <p className={`${isOverdue ? 'text-red-600 font-medium' : 'text-gray-500'}`}>
                Prochain : {new Date(lastIntervention.nextDueDate).toLocaleDateString('fr-FR')}
              </p>
            )}
          </>
        ) : (
          <p className="text-gray-400 italic">Aucune intervention enregistrée</p>
        )}
      </div>

      {onAddIntervention && (
        <button
          onClick={() => onAddIntervention(type)}
          className="mt-3 text-xs bg-primary/10 text-primary px-3 py-1.5 rounded-lg hover:bg-primary/20 transition font-medium"
        >
          + Nouvelle intervention
        </button>
      )}
    </div>
  );
};

export default MaintenanceCard;
